import { useOpenEventPageModal } from "@Modules/eventPage/utils/modalFunctionalities";
import { SELECTORS } from "@Redux";
import { MODAL_TYPES } from "@Utils";
import { useSelector } from "react-redux";
import { IReviewsProps } from "./IReviews";

const useReviews = ({ closeModal }: IReviewsProps) => {
    const event = useSelector(SELECTORS.event);

    const { handleOpen } = useOpenEventPageModal();

    const reviewsMiscellaneousData = event?.miscellaneousData?.reviews || {};
    const reviews = reviewsMiscellaneousData.data || [];
    const avgRating = reviewsMiscellaneousData.avgRating || 0;

    const handleShowReviews = (): void => {
        handleOpen(MODAL_TYPES.Reviews, {
            modalProps: {
                rating: avgRating,
                reviews,
                handleClose: closeModal,
            },
        });
    };

    return {
        hideComponent: !reviews.length,
        reviews,
        avgRating: reviewsMiscellaneousData.avgRating || 0,
        handleShowReviews,
    };
};

export default useReviews;
